import { useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import Slider from "react-slick"

import Style from "./style"
import defaultImg from "./asset/default.jpg"

import useGetAdList from "entity/column/useGetAdList"

const AdBanner = () => {
    const navigate = useNavigate()

    const [adList] = useGetAdList()

    const sliderConfig = {
        "dots": false,
        "arrows": false,
        "infinite": adList?.data?.ad_list?.length == 1 ? false : true,   // NOTE: 이미지가 1개일 때 true를 주면 버그 발생
        "autoplay": true,
        "pauseOnHover": true,
        "pauseOnFocus": true,
        "speed": 700,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "beforeChange": (_, nextIndex) => setImgListIndex(nextIndex)
    }

    const mouseDownCheckRef = useRef(false)
    const dragCheckRef = useRef(false)
    const [imgListIndex, setImgListIndex] = useState(0)

    return (
        <Style.BannerDiv>
            {adList?.data?.ad_list?.length > 0
                ? <Slider {...sliderConfig}>
                    {adList?.data?.ad_list?.map(elem =>
                        <Style.BannerElem
                            onClick={() => !dragCheckRef.current && navigate(`/ad/${elem?.idx}/detail`)}
                            onMouseDown={() => mouseDownCheckRef.current = true}
                            onMouseMove={() => mouseDownCheckRef.current ? dragCheckRef.current = true : dragCheckRef.current = false}
                            onMouseUp={() => mouseDownCheckRef.current = false}
                        >
                            <Style.BackgroundImg src={elem.banner_img} />
                        </Style.BannerElem>
                    )}
                </Slider>
                : <Style.BackgroundImg src={defaultImg} />
            }
            {adList?.data?.ad_list?.length > 0 &&
                <Style.PageDiv>
                    <p>{imgListIndex + 1}<span>/</span>{adList?.data?.ad_list?.length}</p>
                </Style.PageDiv>
            }
        </Style.BannerDiv >
    )
}

export default AdBanner